import React, { useEffect, useMemo } from 'react';
import { useMachine } from '@xstate/react';
import { useApolloClient } from '@apollo/client';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useMount, useUnmount } from 'react-use';
import { useScript } from 'hooks/use-script.hook';
import { useSessionContext } from 'contexts/session';
import { useAccountContext } from 'contexts/account';
import { Page } from 'styles';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import {
  HELP_WIDGET_SCRIPT_URL,
  HELP_WIDGET_ID,
  helpWidgetSettings,
  hideHelpWidget,
  showHelpWidget,
} from 'utils/help-widget';
import { BackButton } from 'components/back-button';
import { createStateMachine, events } from './state-machine';

const showDevTools = import.meta.env.MODE === 'development';

const getMeta = current => Object.values(current.meta)[0];

export const Moving = () => {
  useScript(HELP_WIDGET_SCRIPT_URL, HELP_WIDGET_ID);
  const { userId } = useSessionContext();
  const { selectedAccountId } = useAccountContext();
  const history = useHistory();
  const apolloClient = useApolloClient();
  const stateMachine = useMemo(
    () => createStateMachine(apolloClient, userId, selectedAccountId),
    [userId]
  );
  const [current, send, service] = useMachine(stateMachine, {
    context: {
      history,
      userId,
      accountId: selectedAccountId,
    },
    devTools: showDevTools,
  });
  const { initial, states } = stateMachine.config;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'route' does not exist on type '{}'.
  const { route, previousRoute, Component } = getMeta(current);
  const { matches } = current;

  useMount(() => {
    helpWidgetSettings();
    showHelpWidget();
  });

  useUnmount(() => {
    service.stop();
    hideHelpWidget();
  });

  useEffect(() => {
    if (route) {
      history.push(route);
    }
  }, [history, route]);

  const next = data => {
    return send(events.next, { data });
  };

  const component = (
    <Component
      next={next}
      context={current.context}
      matches={current.matches}
      send={send}
    />
  );

  const screen = <Route path={route} render={() => component} />;

  const showBackButton = !matches('viewSuccess');

  return (
    <>
      {showBackButton && (
        <BackButton
          previousRoute={previousRoute}
          onClick={() => send(events.previous)}
        />
      )}
      <Page
        maxWidth={MAX_SECONDARY_PAGE_WIDTH}
        small={{ margin: { top: '32px' } }}
      >
        {screen}
        {/* @ts-expect-error ts-migrate(2538) FIXME: Type 'symbol' cannot be used as an index type. */}
        <Redirect to={states[initial].meta.route} />
      </Page>
    </>
  );
};
